import { Component, OnInit, Input, ViewChild, ElementRef } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import moment from 'moment';

//services
import { TimecardService } from 'src/app/pages/timecard/services/timecard.service';

@Component({
  selector: 'app-load-map-modal',
  templateUrl: './load-map-modal.component.html',
  styleUrls: ['./load-map-modal.component.css']
})
export class LoadMapModalComponent implements OnInit {
  @ViewChild('map2Div') map2Div: ElementRef;
  @Input() data: any;
  @Input() timecardPersistID: any;
  map: any;
  greenMarker: any;
  yellowMarker: any;
  redMarker: any;
  mapPoints: any[] = [];
  filteredPoints: any[] = [];
  jobPoints: any[] = [];

  constructor(private activeModal: NgbActiveModal, private timecardService: TimecardService) {
  }

  ngOnInit(): void {
    //Google Maps
    this.map = null;
    this.greenMarker = 'https://www.google.com/intl/en_us/mapfiles/ms/micons/green-dot.png';
    this.yellowMarker = 'https://www.google.com/intl/en_us/mapfiles/ms/micons/yellow-dot.png';
    this.redMarker = 'https://www.google.com/intl/en_us/mapfiles/ms/micons/red-dot.png';

    this.timecardService.getPointsByTimecardPersistID(this.timecardPersistID, moment(this.data.Date).utc().format('YYYY-MM-DD')).then((response: any) => {
      if (response != null) {
        this.mapPoints = response;
        for (let i = 0; i < this.mapPoints?.length; i++) {
          const date = moment.utc(this.mapPoints[i].ClockTime);
          this.mapPoints[i].DisplayTime = date.format('LT');
          this.mapPoints[i].DisplayDate = date.format('L');
        }
        this.filteredPoints = this.mapPoints;
        if (this.mapPoints?.length > 0) {
          this.timecardService.getJobLocationPoints(this.timecardPersistID, moment(this.data.Date).utc().format('YYYY-MM-DD')).then((response: any) => {
            this.jobPoints = response;
            setTimeout(() => {
              this.map = new google.maps.Map(this.map2Div?.nativeElement, { zoom: 8 });
              this.mapAllPoints();
            }, 0);
          });
        }
      }
    });
  }

  //GPS 
  mapSinglePoint(point: any) {
    if (point.GPSLat != null && point.GPSLong != null) {
      this.map = new google.maps.Map(this.map2Div?.nativeElement, { zoom: 8 });
      const bounds = new google.maps.LatLngBounds();
      if (point.ClockAction) {
        const marker: any = new google.maps.Marker({
          position: new google.maps.LatLng(parseFloat(point.GPSLat), parseFloat(point.GPSLong)),
          map: this.map,
          icon: this.greenMarker
        });
        bounds.extend(marker.position);
      }
      else {
        const marker: any = new google.maps.Marker({
          position: new google.maps.LatLng(parseFloat(point.GPSLat), parseFloat(point.GPSLong)),
          map: this.map,
          icon: this.redMarker
        });
        bounds.extend(marker.position);
      }
      this.map.fitBounds(bounds);
    }
  }

  mapAllPoints() {
    const bounds = new google.maps.LatLngBounds();
    let pointsToBind = this.jobPoints?.length;
    this.filteredPoints = this.mapPoints;
    for (let i = 0; i < this.jobPoints?.length; i++) {
      let address = this.jobPoints[i].JobAddress;
      if (this.jobPoints[i].JobAddress2) { address += ' ' + this.jobPoints[i].JobAddress2; }
      address += ', ' + this.jobPoints[i].JobCity + ', ' + this.jobPoints[i].JobState;
      if (this.jobPoints[i].JobZip) { address += ' ' + this.jobPoints[i].JobZip; }
      this.timecardService.getMapCoordinates(address).then((response: any) => {
        if (response.status == 200) {
          const marker: any = new google.maps.Marker({
            position: new google.maps.LatLng(response.Latitude, response.Longitude),
            map: this.map,
            icon: this.yellowMarker
          });
          bounds.extend(marker.position);
          pointsToBind--;
          if (pointsToBind == 0)
            this.map.fitBounds(bounds);
        }
      },
        () => {
          pointsToBind--;
          if (pointsToBind == 0)
            this.map.fitBounds(bounds);
        });
    }
    for (let i = 0; i < this.mapPoints?.length; i++) {
      if (this.mapPoints[i].GPSLat != null && this.mapPoints[i].GPSLong != null) {
        let marker;
        if (this.mapPoints[i].ClockAction) {
          marker = new google.maps.Marker({
            position: new google.maps.LatLng(parseFloat(this.mapPoints[i].GPSLat), parseFloat(this.mapPoints[i].GPSLong)),
            map: this.map,
            icon: this.greenMarker
          });
        }
        else {
          marker = new google.maps.Marker({
            position: new google.maps.LatLng(parseFloat(this.mapPoints[i].GPSLat), parseFloat(this.mapPoints[i].GPSLong)),
            map: this.map,
            icon: this.redMarker
          });
        }
        bounds.extend(marker.position);
      }
    }
    if (pointsToBind == 0)
      this.map.fitBounds(bounds);
  }

  closeClicked() {
    this.activeModal.dismiss();
  }

}